/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{colorGamma as o,invColorGamma as e}from"../../../../../../colorUtils.js";import{glsl as r}from"../../shaderModules/glsl.js";function a(a){a.constants.add("GAMMA","float",o).constants.add("INV_GAMMA","float",e).code.add(r`vec3 delinearizeGamma(vec3 color) {
return pow(color, vec3(INV_GAMMA));
}
vec4 delinearizeGamma(vec4 color) {
return vec4(delinearizeGamma(color.rgb), color.a);
}
vec3 linearizeGamma(vec3 color) {
return pow(color, vec3(GAMMA));
}`)}export{a as Gamma};
